/**
 * Created by comoon on 1/19/16.
 * 准A计划的详情页入口js
 */

var $ = require("jquery");

var moment = require("moment");

moment.locale("zh-cn");

var ReactDOM = require("react-dom");

var ALikeStore = require("../store/ALikeStore");

var QuoteApp = require("../detail/QuoteApp");

var QuoteAppB = require("../detail-b/QuoteApp.jsx");

var ProductListApp = require("../detail/ProductListApp");

var ExtraProductTips = require("../detail/ExtraProductTips");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var TripType = require("../conf/trip-type");


var DetailUIContainer = require('../UIContainer/DetailUIContainer');

var SaleNotify = require('../detail/SaleNotify');


$(function () {
    var tripContainer = $(".alike-container");

    var tripInfo = tripContainer.data();

    Dispatcher.dispatch({type: ActionConstants.INIT_TRIP_INFO, data: tripInfo});

    var tripSummary = $(".trip-summary");

    tripSummary.on("mouseover click", ".trip-city", function () {

        $(this).addClass("selected").siblings(".trip-city").removeClass("selected");
    });


    var daysProfile = $(".days-profile");

    /**
     * 显示每一天的POA详情的旋转木马
     * 旋转木马<b>向前</b>
     * carousel to show day poa list
     * carousel <b>previous</b>
     */
    daysProfile.on("click", ".poi-carousel-container .previous", function () {

        var container = $(this).closest(".poi-carousel-container");

        moveCarousel(container, 3, false);
        hiddenNextBtn(container);
    });

    /**
     * 显示每一天的POA详情的旋转木马
     * 旋转木马<b>向后</b>
     * carousel to show day poa list
     * carousel <b>next</b>
     */
    daysProfile.on("click", ".poi-carousel-container .next", function () {

        var container = $(this).closest(".poi-carousel-container");

        moveCarousel(container, 3, true);
        hiddenNextBtn(container);
    });

    function hiddenNextBtn(container){
        var total = $(container).data().total || 0;
        var current = $(container).data().current || 0;
        if(total%3 == 0){
            $(container).addClass("lastPage");
        }else{
            if(parseInt(total/3) === parseInt(current/3)){
                $(container).addClass("lastPage");
            }else{

                $(container).removeClass("lastPage");            }
        }
    }

    /**
     * 显示日程地点的旋转木马
     * 旋转木马<b>向前</b>
     * carousel to show schedule list
     * carousel <b>previous</b>
     */
    daysProfile.on("click", ".day-indicator.previous", function () {

        var container = $(this).closest(".days-tab-switcher");

        moveCarousel(container, 3, false);
    });

    /**
     * 显示日程地点的旋转木马
     * 旋转木马<b>向后</b>
     * carousel to show schedule list
     * carousel <b>next</b>
     */
    daysProfile.on("click", ".day-indicator.next", function () {

        var container = $(this).closest(".days-tab-switcher");

        moveCarousel(container, 3, true);
    });


    daysProfile.on("click", ".day-tab.switcher", function () {

        var switcher = $(this);

        switcher.addClass('selected').siblings('.switcher').removeClass('selected');

        var day = switcher.data('day');

        daysProfile.find(".day-activities.day-" + day)
            .addClass("selected")
            .siblings('.day-activities')
            .removeClass('selected');
    });

    var quoteContainer = $(".quote-container");

    var saleNotifyWrapper = $('.js-sale-notify');


    var inProductListWrapper = $(".in-price-profile");

    var absentProductListWrapper = $(".absent-price-profile");

    var trip = ALikeStore.get_tripBasicInfo();
    //准AA or 准AB
    var isTripA = (trip.tripType === TripType.WalleA.code) ? true: false;

    if(isTripA){

        ReactDOM.render(<QuoteApp trip={tripInfo} />, quoteContainer[0]);

        // 销售计价提示
        ReactDOM.render(<SaleNotify role={ tripInfo.pageStatus } uid={ tripInfo.validUid } />, saleNotifyWrapper[0]);

    }else{
        ReactDOM.render(<QuoteAppB trip={tripInfo} />, quoteContainer[0]);
        //暂时隐藏
        $(".util-no-href").remove();
        $(".title .see-detail").remove();

    }




    ReactDOM.render(<ProductListApp trip={tripInfo} />, inProductListWrapper[0]);

    ReactDOM.render(<ProductListApp trip={tripInfo} absent/>, absentProductListWrapper[0]);

    ReactDOM.render(<ExtraProductTips/>, $('.extra-tips-price-profile')[0]);

    ReactDOM.render(<DetailUIContainer></DetailUIContainer> , $('.js-ui-container')[0]);


    function moveCarousel(container, step, next) {

        var implementer = container.find(".carousel-implementer");

        var total = container.data("total");

        var current = implementer.data("current");

        implementer.removeClass("current-" + current);

        container.removeClass("current-" + current);

        if (next) {

            if ((current + step) <= total) {

                current = Math.min(total, current + step);
            } else {
                current = 1;
            }

        } else {

            current = Math.max(1, current - step);
        }

        implementer.addClass("current-" + current);

        container.addClass("current-" + current);

        implementer.attr('data-current', current).data("current", current);

        container.attr('data-current', current).data("current", current);
    }


    //fancybox
    $('.js-video-view').each(function(){

        $(this).fancybox({
            wrapCSS: 'track-poa-dialog aplan-poa-dialog',
            maxWidth  : 800,
            maxHeight : 450,
            padding: 0,
            fitToView : false,
            href: $(this).attr('data-thref').replace("http://", "https://"),
            width   : 800,
            height    : 450,
            autoSize  : false,
            closeClick  : false,
            openEffect  : 'none',
            closeEffect : 'none',
            ajax: {
                'type': 'post'
            }
        });
    });

    $('.js-text-view').each(function(){

        $(this).fancybox({
            wrapCSS: 'track-poa-dialog aplan-poa-dialog ntrip-poa-dialog',
            maxWidth  : 800,
            maxHeight : 545,
            padding: 0,
            fitToView : false,
            href: $(this).attr('data-thref').replace("http://", "https://"),
            width   : '75%',
            height    : '92%',
            autoSize  : false,
            closeClick  : false,
            openEffect  : 'none',
            closeEffect : 'none',
            ajax: {
                'type': 'post'
            },
            helpers: {
              title: {
                type: "inside",
                position: "top"
              }
            }
        });
    });


    var btn = $("div.js_bottom_panel").find('.js_submit');
    btn.click(function(){
        var tid = $(this).data("tid");
        $.ajax({
            url: '/a/trip/walle/commit/?tid='+tid,
            type:'post',
            dataType:'json',
            success:function(data){
                if(!data.code){
                    $.cpWin.alert({
                        msg:'提交成功。',
                        subHandle:function(){
                            $.cpReload();
                        }});
                }else{
                    $.cpWin.alert({
                        type:'hintErr',
                        msg:data.msg
                    });
                }
            }
        });

    });
    ALikeStore.on(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, function () {
        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());
        if(!version){
            return
        }
        var startDate = version.startDate;
        resetWeekDom();
        setWeekDay(startDate);

    });

    var quteContainer = $(".quote-container-iml");
    var dayItems = $(".days-profile .switcher > span.k");
    var startItem = $(".days-profile .start > span.k");
    var endItem = $(".days-profile .end > span.k");
    var weekdays = ["日", "一", "二", "三", "四", "五", "六"];
    quteContainer.on("click", ".qr-item", function(){
        resetWeekDom();
        var startdate = $(this).data().startdate;
        setWeekDay(startdate);
    });

    quteContainer.on("click", ".day-price", function(){
        resetWeekDom();
        var startdate = $(this).data().startdate;
        setWeekDay(startdate);
    });
    function resetWeekDom(){
        $(".days-profile .switcher span.d").remove();
        $(".days-profile .start span.d").remove();
        $(".days-profile .end span.d").remove();
    }
    /**
     * 启程: startDay
     * DAY-1 +startOffset
     * DAY-2 DAY-1+1
     * 返程: startDay + 天数+ endOffset
     * @param e
     */
    function setWeekDay(date){
        var startOffset = window.startOffset || 0;
        var endOffset = window.endOffset || 0;
        var startDate = date;
        var dayLength = dayItems.length;
        var endDate = null;
        var setp = 0;
        //启程
        $(startItem).after("<span class='d'>"+  moment(startDate).format("M-DD") +" "+ weekdays[moment(startDate).day()] +"</span>");
        _.each(dayItems, function(i,j){
            setp = j===0 ? startOffset+j : setp+1;
            var date = moment(startDate).add("day", setp);
            var d = date.day();
            var day = date.format("M-DD");
            var week = weekdays[d];
            endDate = j===dayLength-1 ? date : endDate;
            $(i).after("<span class='d'>"+ day +" "+ week +"</span>")
        })
        //返程
        $(endItem).after("<span class='d'>"+  moment(endDate).format("M-DD") +" "+ weekdays[moment(endDate).day()] +"</span>");
    }
});


require("../detail/nav-follow");



/** WEBPACK FOOTER **
 ** ./script/entry/detail.js
 **/